import { LoadingButton } from '@mui/lab'
import { Badge, Box, IconButton, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { DinamicForm } from '../../../../../components/dinamicForm'
import Loader from '../../../../../components/loader'
import { useContextState } from '../../../../../hooks/theme'
import { questionarieServise } from '../../../../../service/questionarie'
import { httpFetch } from '../../../../../utils/crud'
import { icons } from '../../../../../utils/icons'
import { InputModel } from '../../../../../utils/types'
import { useStyles } from './styles'
import { Constants } from '../../../../../utils/constants'
import { format } from 'date-fns'
import useGlobalErrors from '../../../../../hooks/erors'
import { initialEvidences } from '../../../models'
import { DrawerEvidences } from '../../../../../components/evidences'
import { EvidenceOptionType } from '../../../../../hooks/evidences/typyng'
import { useEvidencesType } from '../../../../../hooks/evidences/useEvidences'
import { questiononEvidencesToEvidenceData, separateEvidenceType } from '../../../../questionnaire/pages/detail/contextProvider/provider/methods'
import { removeAllReference } from '../../../../../utils/methods/removedReference'
import { convertEvideceArray, getEvidenceData } from '../../../../questionnaire/pages/detail/methods'
import { useParams } from 'react-router-dom'
import { typeUser } from '../../../../questionnaire/pages/detail/methods/actionPlan/contants'

const defaultValue = {
  "sizes": "255",
  "required": false,
  "evidenceTypeId": 8,
  "type": "APPROVER"
}
const Form = ({ btnLoading, data, input, crudChange, cancel, hideInfo, info, submit, deleteConfig, canSubmit, isEditing, evidences, isLoading, canEdit }: any) => {
  const { colors } = useContextState()
  const { id } = useParams()
  const { t } = useTranslation()
  const styles = useStyles(colors)
  const [arrayInfo, setArrayInfo] = useState<any>([])
  const [evidenceArray, setEvidenceArray] = useState()
  const evidencesFolioComment = useEvidencesType({})
  const evidencesFolio = useEvidencesType({})
  const [dataError, setDataError] = useState<any>()
  const { errors } = useGlobalErrors({ data: dataError, t, values: data })

  const getData = async () => {
    const evidenceTypeResponse = await questionarieServise(httpFetch).getEvidenceType()

    const evidenceArray = !evidenceTypeResponse.errors
      ? evidenceTypeResponse?.map((item: any) => ({
        label: item.description,
        name: item.key,
        type: 'switch',
        value: false,
        rest: {
          id: item.id,
        },
        size: {
          lg: 12,
        },
      }))
      : []

    setEvidenceArray(evidenceArray)
  }
  const emitForm = () => {
    const { allowDuplicates, limitFoliosAmount, maxRejectionsAmount, mandatorySurvey, satisfactionQuestion, enableSurvey, limitFolio, maxRejections } = data
    const questionEvidence = convertEvideceArray([...evidencesFolioComment.evidencesData, ...evidencesFolio.evidencesData])
    const evidenceData = getEvidenceData({ evidenceType: questionEvidence as any })
    // const existApprove = evidenceData?.find(item => item?.type == typeUser.APPROVER)
    // const existReject = evidenceData?.find(item => item?.type == typeUser.REJECT)
    // if (!existApprove) { evidenceData.push(defaultValue) }
    // if (!existReject) { evidenceData.push({ ...defaultValue, type: typeUser.REJECT }) }
    submit({
      askForArea: true,
      isAreaRequired: true,
      askForDepartment: true,
      isDepartmentRequired: true,
      reportFolioGeneral: true,
      allowDuplicates: !allowDuplicates,
      max: limitFolio ? limitFoliosAmount ?? '1' : null,
      maxRejects: maxRejections ? maxRejectionsAmount ?? '1' : null,
      ...(!!enableSurvey && { ratingQuestion: satisfactionQuestion, isRatingQuestionRequired: !!mandatorySurvey }),
      enableRatingQuestion: enableSurvey,
      configActionPlanReportFolioEvidenceTypes: evidenceData ?? [],
    })
  }
  useEffect(() => {
    if (evidences instanceof Array) {
      const { approver, reject, create } = separateEvidenceType(removeAllReference(evidences))
      evidencesFolioComment.fillData({ defaultValues: [questiononEvidencesToEvidenceData(approver), questiononEvidencesToEvidenceData(reject, typeUser.REJECT)] })
      evidencesFolio.fillData({ defaultValues: [questiononEvidencesToEvidenceData(create)] })
    }
  }, [evidences])

  useEffect(() => {
    getData()
  }, [])

  useEffect(() => {
    let data: { [x: string]: InputModel } = {}
    input?.forEach((item: any) => {
      data = { ...data, [item.name]: item }
    })
    setDataError(data)
  }, [input])

  useEffect(() => {
    if (info && !info?.errors) {
      const createdBy = `${info.createdBy?.firstName ?? ''} ${info.createdBy?.lastName ?? ''}`
      const createTime = format(new Date(info.createTime), Constants.dateFormat2)
      setArrayInfo([
        { label: 'ID', value: info.id || 'N/A' },
        { label: 'Áreas', value: info.areas || 'N/A' },
        { label: 'Departamentos', value: info.departments || 'N/A' },
        { label: '# Usuarios Activos', value: info.users },
        { label: 'Actualizado por', value: createdBy || 'N/A' },
        { label: 'Actualizado el', value: createTime || 'N/A' },
      ])
    }
  }, [info])

  useEffect(() => {
    const evidenceType = initialEvidences({ evidenceArray: evidenceArray ?? [], evidenceData: evidences })

    let expands: string[] = []
    Object.entries(evidenceType)?.forEach(([key, itemValues]) => {
      if (!!itemValues.status) {
        expands = [...expands, key]
      }
    })
  }, [evidences, evidenceArray])

  return btnLoading ? (
    <Box sx={styles.loader}>
      <Loader />
    </Box>
  ) : (
    <>
      <Box sx={styles.container}>
        {!hideInfo && (
          <>
            <Typography
              sx={{
                fontSize: '17px',
                fontWeight: '600',
                color: '#707070',
                marginBottom: '20px',
                // textAlign: 'center',
              }}
            >
              {t('reportFolio.detail.general.folioConfig')}
            </Typography>
            <Box sx={{ marginBottom: 2, fontSize: '14px' }}>
              {arrayInfo?.map((item: any) => (
                <Box sx={styles.info}>
                  <Box sx={styles.left}>{item.label}</Box>
                  <Box sx={styles.right}>{item.value}</Box>
                </Box>
              ))}
            </Box>
          </>
        )}

        <DinamicForm input={input} values={data} onChange={crudChange} disabled={info} justifyContentLeft />

        <Box sx={styles.evidences}>
          <Badge sx={styles.badge} badgeContent={evidencesFolio.evidencesCount}>
            <IconButton
              onClick={(e) => {
                evidencesFolio.clickOption({})
              }}
              sx={[styles.clip]}
              disabled={false}
            >
              {icons('clip')}
            </IconButton>
          </Badge>

          <Typography
            sx={{
              fontSize: '13px',
              fontWeight: '600',
              color: '#707070',
            }}
          >
            {t('general.creationEvidence')}
          </Typography>
        </Box>

        <Box sx={styles.evidences}>
          <Badge sx={styles.badge} badgeContent={evidencesFolioComment.evidencesCount}>
            <IconButton
              onClick={(e) => {
                evidencesFolioComment.clickOption({})
              }}
              sx={[styles.clip]}
              disabled={false}
            >
              {icons('clip')}
            </IconButton>
          </Badge>

          <Typography
            sx={{
              fontSize: '13px',
              fontWeight: '600',
              color: '#707070',
            }}
          >
            {t('general.managemetFolioEvidence')}
          </Typography>
        </Box>

        {!isEditing && (
          <Box sx={styles.buttons}>
            <LoadingButton loading={isLoading} sx={{ mt: 2 }} variant="contained" onClick={emitForm} disabled={Object.keys(errors).length > 0 || !canSubmit}>
              {t('general.saveConfig')}
            </LoadingButton>
          </Box>
        )}

        {isEditing && (
          <Box sx={styles.buttons}>
            <LoadingButton loading={isLoading} sx={{ mt: 2, textTransform: 'uppercase' }} variant="contained" onClick={emitForm} disabled={(Object.keys(errors).length > 0 || !canSubmit) && !info}>
              {t(`general.${canEdit ? 'saveConfig' : 'edit'}`)}
            </LoadingButton>

            <LoadingButton sx={styles.btnCancel} variant="contained" onClick={deleteConfig}>
              {t('general.delete')}
            </LoadingButton>
          </Box>
        )}
      </Box>

      <DrawerEvidences
        disabledField={!canEdit}
        headerLabel={t('general.returnreportFolioConfig')}
        headerElement={<Typography sx={styles.titleEvidences}>{t('general.folioConfig')}</Typography>}
        optionType={EvidenceOptionType.FOLIO_MANAGEMENT}
        refsByKey={evidencesFolioComment?.refsByKey}
        defaultValues={evidencesFolioComment?.evidencesData}
        open={!!evidencesFolioComment?.openEvidenceDrawer}
        setRef={evidencesFolioComment?.setRef}
        save={(data) => {
          evidencesFolioComment?.saveEvidence(data || [],)
        }}
        cancel={() => {
          evidencesFolioComment?.cancelEvidence()
        }}
      />

      <DrawerEvidences
        disabledField={!canEdit}
        headerLabel={t('general.returnreportFolioConfig')}
        optionType={EvidenceOptionType.CREATION}
        refsByKey={evidencesFolio?.refsByKey}
        defaultValues={evidencesFolio?.evidencesData}
        open={!!evidencesFolio?.openEvidenceDrawer}
        setRef={evidencesFolio?.setRef}
        save={(data) => {
          evidencesFolio?.saveEvidence(data || [],)
        }}
        cancel={evidencesFolio?.cancelEvidence}
      />
    </>
  )
}

export default Form
